import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "../../pages/api/axios";
import FeatherIcon from "feather-icons-react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import sidebarIconFor from "./sidebarIconFor";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import jwt_decode from "jwt-decode";

const SidebarContent = (props) => {
  const [dashboardData, setDashboardData] = useState("");
  const [residentApplicationInfo, setResidentApplicationInfo] = useState({
    Total: 0,
    Pending: 0,
    Approved: 0,
    Denied: 0,
  });
  const [viewLeadsInfo, setViewLeadsInfo] = useState({
    total: 0,
    closed: 0,
    pending: 0,
    cancelled: 0,
    follow_up: 0,
  });
  const [appointmentsInfo, setAppointmentsInfo] = useState({
    total: 0,
    booked: 0,
    pending: 0,
    rejected: 0,
  });
  const [maintenanceRequestInfo, setMaintenanceRequestInfo] = useState({
    total: 0,
    open: 0,
    inprogress: 0,
    completed: 0,
    unresolved: 0,
  });

  const ref = useRef();

  const accessToken = window.localStorage.getItem("accessToken");
  let decoded = null;
  let role = null;
  let isLead = false;
  if (accessToken) {
    try {
      decoded = jwt_decode(accessToken);
      const expDate = new Date(decoded.exp * 1000);
      if (Date.now() <= expDate.getTime()) {
        role = window.localStorage.getItem("role");
        isLead = JSON.parse(window.localStorage.getItem("authUser"))?.userData?.lead || false;
      }
    } catch (error) { }
  }

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent?.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        const scrollEl = ref.current?.getScrollElement();
        if (scrollEl) {
          scrollEl.scrollTop = currentPosition - 300;
        }
      }
    }
  }

  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul?.getElementsByTagName("a") || [];
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    initMenu();
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate();
    }
  }, []);

  const getApplicants = async (url, data) => {
    try {
      const response = await axios.post(url, data);
      if (response.status === 200 && response.data.results?.applications) {
        setResidentApplicationInfo((prev) => ({
          ...prev,
          Total: response.data.total?.Total || 0,
          Pending: response.data.total?.Pending || 0,
          Approved: response.data.total?.Approved || 0,
          Denied: response.data.total?.Denied || 0,
        }));
      }
    } catch (error) {
      console.error("Unable to get applicants", error);
    }
  };

  const getLeads = async () => {
    try {
      const response = await axios.get(`/leads/getLeadsManager?page=1&limit=10`);
      if (response.data?.success && response.data.leads?.length > 0) {
        setViewLeadsInfo((prev) => ({
          ...prev,
          total: response.data.total?.Total || 0,
          pending: response.data.total?.Pending || 0,
          closed: response.data.total?.Closed || 0,
          cancelled: response.data.total?.Cancelled || 0,
          follow_up: response.data.total?.["Follow Up"] || 0,
        }));
      }
    } catch (error) {
      console.error("Error fetching leads", error);
    }
  };

  const searchTicket = async (decoded) => {
    try {
      let query = {};
      let response;
      if (decoded.role === "manager") {
        query = { managerID: decoded.id };
        response = await axios.post("/ticket/filter_tickets_manager", query);
      }
      if (response?.status === 200) {
        setMaintenanceRequestInfo((prev) => ({
          ...prev,
          total: response.data.total?.Total || 0,
          open: response.data.total?.Open || 0,
          completed: response.data.total?.Completed || 0,
          inprogress: response.data.total?.Inprogress || 0,
          unresolved: response.data.total?.Unresolved || 0,
        }));
      }
    } catch (error) {
      console.error("Error fetching tickets", error);
    }
  };

  const getAppointments = async (decoded) => {
    try {
      const query = { manager_id: decoded.id };
      const res = await axios.post("/user_appointment/get-pending-slot", query, {
        headers: { "Content-Type": "application/json" },
      });
      const data = res.data;
      setAppointmentsInfo((prev) => ({
        ...prev,
        total: data?.total?.Total || 0,
        booked: data?.total?.booked || 0,
        pending: data?.total?.pending || 0,
        rejected: data?.total?.rejected || 0,
      }));
    } catch (error) {
      console.error("Error fetching appointments", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!decoded || !role) return;

      if (role === "company") {
        try {
          const navdataResponse = await axios.post("/navdata/maintenancerequests", {
            companyDomain: decoded.domain,
            managerID: decoded.id,
          });

          const residentApplicationsResponse = await axios.post(
            "/navdata/residentapplications?page=1&limit=10",
            { role: decoded.role, domain: decoded.domain }
          );

          const pendingSlotsResponse = await axios.post(
            "/user_appointment/get-pending-slot",
            { manager_id: decoded.id }
          );

          setDashboardData({
            maintenanceTickets: navdataResponse.data?.openTicketsCount,
            residentApplications: residentApplicationsResponse.data.total?.Pending || 0,
            pendingSlots: pendingSlotsResponse.data,
          });
        } catch (error) {
          console.error("Error fetching company data:", error);
        }
      } else if (role === "manager") {
        await getApplicants(`/applicant/list?page=1&limit=10`, {
          role: decoded.role,
          managerID: decoded.id,
        });
        await getLeads();
        await searchTicket(decoded);
        await getAppointments(decoded);
      }
    };

    fetchData();
  }, [role]);

  useEffect(() => {
    if (!accessToken || !decoded || !role) {
      window.localStorage.removeItem("role");
      window.localStorage.removeItem("accessToken");
      window.location.replace("/login");
    }
  }, [accessToken, decoded, role]);

  if (!decoded || !role) return null;

  const roleMenus = {
    admin: [
      {
        className: "facilities-li",
        icon: "briefcase",
        title: "Companies",
        link: "/company",
      },
      {
        icon: "briefcase",
        title: "RDCare Leads",
        hasArrow: true,
        subItems: [{ title: "View Leads", link: "/viewRentdigiLeads" }],
      },
      {
        icon: "file-text",
        title: "RDCare Blogs",
        hasArrow: true,
        subItems: [
          { title: "Add Blogs", link: "/addblog" },
          { title: "Blog List", link: "/blog" },
          { title: "Edit Blog", link: "/editblog" },
        ],
      },
      {
        icon: "file-text",
        title: "RDCare Newsletters",
        hasArrow: true,
        subItems: [{ title: "View Newsletters", link: "/newsletters" }],
      },
      {
        icon: "tool",
        title: "Vendor Speciality",
        link: "/vendor-specialty",
      },
      {
        icon: "users",
        title: "Vendors",
        hasArrow: true,
        subItems: [{ title: "View Vendors", link: "/viewvendor" }],
      },
    ],

    company: [
      { icon: "grid", title: "Dashboard", link: "/dashboard" },
      {
        icon: "tool",
        title: "Maintenance Operations",
        hasArrow: true,
        subItems: [
          {
            title: "Maintenance Requests",
            hasArrow: true,
            subItems: [
              { title: "All Requests", link: "/tickets_list" },
              { title: "Email Notifications", link: "/emailnotification" },
              { title: "Entry Permissions", link: "/permissions" },
              { title: "Request Types", link: "/request_type" },
              { title: "API Access", link: "/api-access" },
            ],
          },
          {
            title: "Maintenance Team",
            hasArrow: true,
            subItems: [
              { title: "Add Category", link: "/add_specialities" },
              { title: "Team Members", link: "/technical_staff" },
            ],
          },
        ],
      },
      {
        icon: "home",
        title: "Building Operations",
        hasArrow: true,
        subItems: [
          { title: "Building Inspections", link: "/building-inspections" },
          { title: "Incident Reports", link: "/incident-reports" },
          { title: "Suite Inspections", link: "/suite-inspections" },
          { title: "Inspection Tracker", link: "/tracker/suite-inspections" },
          { title: "Vendor Inspection Report", link: "/vendor-inspection-report" },
          {
            title: "Inventory",
            hasArrow: true,
            subItems: [
              { title: "Facility Items", link: "/facility-item-management" },
              { title: "Manage Inventory", link: "/inventory-items-management" },
              { title: "RM Vendors", link: "/inventory-rm-vendor-management" },
            ],
          },
          { title: "Snow & Ice Logs", link: "/snow-ice-log/generate" },
        ],
      },
      {
        icon: "dollar-sign",
        title: "Accounting",
        hasArrow: true,
        subItems: [
          { title: "Invoices", link: "/invoices" },
          {
            title: "Statement of Account",
            hasArrow: true,
            subItems: [
              { title: "Approvers", link: "/company/approver" },
              { title: "Auditors", link: "/company/auditor" },
              { title: "View All SOAs", link: "/preview-soa" },
            ],
          },
          { title: "KPI", link: "/kpi-report" },
        ],
      },
      {
        icon: "file-text",
        title: "Mastersheet",
        hasArrow: true,
        subItems: [
          { title: "Active Mastersheet", link: "/master_sheet" },
          { title: "Archived Mastersheet", link: "/archived_master_sheet" },
          { title: "Historic Mastersheet", link: "/historic_master_sheet" },
          { title: "Resident Directory", link: "/resident_directory" },
          { title: "Color Configuration", link: "/master_sheet_color_config" },
          { title: "Move-In / Move-Out", link: "/move-in-out-inspections" },
          { title: "Property Fields", link: "/master_sheet_fields_property_based" },
        ],
      },
      {
        icon: "layers",
        title: "Other Operations",
        hasArrow: true,
        subItems: [
          {
            icon: "cpu",
            title: "Apps & Integrations",
            hasArrow: true,
            subItems: [
              {
                title: "Company Knowledge Base",
                link: "/settings/company-knowledge-base",
              },
              {
                title: "Chatbot Configuration",
                link: "/settings/chat-bot",
              },
              {
                title: "Assistant Leads",
                link: "/assistant-leads",
              },
              {
                title: "Settings Voice Assistant",
                link: "/settings/voice-assistant",
              },
            ],
          },
          {
            icon: "bar-chart-2",
            title: "Report Cards",
            hasArrow: true,
            subItems: [
              { title: "CS Report Card", link: "/reportcard/employee" },
              { title: "Community Leader Report", link: "/reportcard/communityleader" },
              { title: "Overview", link: "/reportcard/list" },
              { title: "R&M Report Card", link: "/reportcard/rnmpersonal" },
            ],
          },
        ],
      },
      {
        icon: "home",
        title: "Properties",
        hasArrow: true,
        subItems: [
          { title: "Accountants", link: "/Accountant" },
          { title: "All Properties", link: "/property" },
          { title: "Property Layout", link: "/property_layout" },
          { title: "Property Managers", link: "/property_manager" },
        ],
      },
      {
        icon: "shopping-cart",
        title: "Sales Operations",
        hasArrow: true,
        subItems: [
          { title: "Applications", link: "/resident_application" },
          {
            title: "Calendar & Appointments",
            hasArrow: true,
            subItems: [
              { title: "Activity Calendar", link: "/activity-calendar" },
              { title: "Approve Appointments", link: "/appointments" },
              { title: "Availability", link: "/calender_availabilty" },
              { title: "Calendar View", link: "/apps-calendar" },
              { title: "Reason Types", link: "/calendar_reasons" },
              { title: "Status Types", link: "/calendar-appointment-status" },
            ],
          },
          {
            title: "Parking Management",
            hasArrow: true,
            subItems: [
              { title: "Assign Parking", link: "/assign_parking" },
              { title: "Parking Layout Setup", link: "/parking_layouts_setup" },
            ],
          },
          {
            title: "Storage Management",
            hasArrow: true,
            subItems: [
              { title: "Assign Storage", link: "/assign_storage" },
              { title: "Storage Layout Setup", link: "/storage_layouts_setup" },
            ],
          },
        ],
      },
      {
        icon: "users",
        title: "Vendors",
        hasArrow: true,
        subItems: [
          { title: "Approve Vendors", link: "/vendors" },
          { title: "Contractors Mastersheet", link: "/contractors" },
          { title: "Vendor Categories", link: "/vendor-specialty" },
          { title: "View Vendors", link: "/viewvendor" },
        ],
      },
    ],

    manager: [
      { icon: "grid", title: "Dashboard", link: "/dashboard" },
      {
        className: "facilities-li",
        icon: "home",
        title: "Properties",
        hasArrow: true,
        subItems: [{ title: "All Properties", link: "/property" }],
      },
      ...(decoded.calendarPrivilege
        ? [
          {
            icon: "calendar",
            title: "Calendar & Appointments",
            hasArrow: true,
            subItems: [
              { title: "Activity Calendar", link: "/activity-calendar" },
              { title: "Calendar View", link: "/apps-calendar" },
              { title: "Availability", link: "/calender_availabilty" },
              {
                title: "Appointments",
                link: "/appointments",
                label: () => {
                  const pending = appointmentsInfo?.pending ?? 0;
                  return pending > 0 ? (
                    <span className="ms-2 badge bg-warning text-dark">
                      {pending} Pending
                    </span>
                  ) : null;
                },
              },
            ],
          },
        ]
        : []),
      ...(decoded.ticketPrivilege
        ? [
          {
            icon: "tool",
            title: "Maintenance Operations",
            hasArrow: true,
            subItems: [
              {
                title: "Maintenance Requests",
                hasArrow: true,
                subItems: [
                  {
                    title: "View Requests",
                    link: "/tickets_list",
                    label: () => {
                      const open = maintenanceRequestInfo?.open?.count ?? 0;
                      return open > 0 ? (
                        <span className="ms-2 badge bg-danger">{open} Open</span>
                      ) : null;
                    },
                  },
                ],
              },
              {
                title: "Maintenance Team",
                hasArrow: true,
                subItems: [
                  { title: "View Maintenance Team", link: "/technical_staff" },
                ],
              },
            ],
          },
        ]
        : []),
      {
        icon: "home",
        title: "Building Operations",
        hasArrow: true,
        subItems: [
          { title: "Building Inspections", link: "/building-inspections" },
          { title: "Incident Reports", link: "/incident-reports" },
          { title: "Suite Inspections", link: "/suite-inspections" },
          { title: "Inspection Tracker", link: "/tracker/suite-inspections" },
          { title: "Vendor Inspection Report", link: "/vendor-inspection-report" },
          { title: "Snow & Ice Logs", link: "/snow-ice-log/generate" },
          { title: "Move-In / Move-Out", link: "/move-in-out-inspections" },
        ],
      },
      {
        icon: "dollar-sign",
        title: "Accounting",
        hasArrow: true,
        subItems: [
          { title: "Invoices", link: "/invoices" },
          ...(decoded.applicationPrivilege
            ? [{ title: "Statement of Account", link: "/generate-soa" }]
            : []),
          { title: "KPI", link: "/kpi-report" },
        ],
      },
      {
        icon: "users",
        title: "Vendors",
        hasArrow: true,
        subItems: [
          { title: "Contractors Mastersheet", link: "/contractors" },
          { title: "Vendors Preview", link: "/vendor_preview" },
        ],
      },
      ...(decoded.applicationPrivilege
        ? [
          {
            icon: "shopping-cart",
            title: "Sales Operations",
            hasArrow: true,
            subItems: [
              {
                title: "Applications",
                link: "/resident_application",
                label: () => {
                  const pending = residentApplicationInfo?.Pending ?? 0;
                  return pending > 0 ? (
                    <span className="ms-2 badge bg-warning text-dark">
                      {pending} Pending
                    </span>
                  ) : null;
                },
              },
              { title: "Assign Parking", link: "/assign_parking" },
              { title: "Assign Storage", link: "/assign_storage" },
            ],
          },
        ]
        : []),
      ...(decoded.masterSheetPrivilege
        ? [
          {
            icon: "file-text",
            title: "Mastersheet",
            hasArrow: true,
            subItems: [
              { title: "Active Mastersheet", link: "/master_sheet" },
              { title: "Archived Mastersheet", link: "/archived_master_sheet" },
              { title: "Historic Mastersheet", link: "/historic_master_sheet" },
              { title: "Resident Directory", link: "/resident_directory" },
            ],
          },
        ]
        : []),
      {
        icon: "layers",
        title: "Other Operations",
        hasArrow: true,
        subItems: [
          {
            icon: "cpu",
            title: "Apps & Integrations",
            hasArrow: true,
            subItems: [
              {
                title: "Assistant Leads",
                link: "/assistant-leads",
              },
            ],
          },
        ],
      },
    ],

    "technical staff": [
      {
        icon: "tool",
        title: "Maintenance Operations",
        hasArrow: true,
        subItems: [
          {
            title: "Maintenance Requests",
            hasArrow: true,
            subItems: [
              { title: "Set Availability Slots", link: "/availabilities" },
              { title: "View Maintenance Requests", link: "/technical_staff_tickets" },
            ],
          },
          {
            title: "Inventory",
            hasArrow: true,
            subItems: [
              ...(isLead
                ? [
                  { title: "Facility Items", link: "/facility-item-management" },
                  { title: "RM Vendors", link: "/inventory-rm-vendor-management" },
                  { title: "Manage Inventory", link: "/inventory-items-management" },
                ]
                : []),
              { title: "Orders", link: "/inventory-orders-management" },
            ],
          },
        ],
      },
      {
        icon: "building",
        title: "Building Operations",
        hasArrow: true,
        subItems: [
          { title: "Building Inspections", link: "/building-inspections" },
          { title: "Incident Reports", link: "/incident-reports" },
          { title: "Suite Inspections", link: "/suite-inspections" },
          ...(isLead
            ? [
              { title: "Inspection Tracker", link: "/tracker/suite-inspections" },
              { title: "Vendor Inspection Report", link: "/vendor-inspection-report" },
            ]
            : []),
          { title: "Snow & Ice Logs", link: "/snow-ice-log/generate" },
          { title: "Move-In / Move-Out", link: "/move-in-out-inspections" },
        ],
      },
      ...(isLead
        ? [
          {
            icon: "dollar-sign",
            title: "Accounting",
            hasArrow: true,
            subItems: [
              { title: "Invoices", link: "/invoices" },
              { title: "Statement of Account", link: "/preview-soa" },
            ],
          },
        ]
        : []),
      {
        icon: "users",
        title: "Vendors",
        hasArrow: true,
        subItems: [{ title: "Vendors Preview", link: "/vendor_preview" }],
      },
    ],

    vendor: [
      {
        icon: "tool",
        title: "Maintenance Operations",
        hasArrow: true,
        subItems: [
          { title: "Maintenance Requests", link: "/working-tickets" },
          {
            title: "Create Maintenance Request",
            link: "/vendor/create-maintenance-request",
          },
        ],
      },
      {
        icon: "building",
        title: "Building Operations",
        hasArrow: true,
        subItems: [
          { title: "Vendor Inspection Report", link: "/vendor-inspection-report" },
          { title: "Snow & Ice Logs", link: "/snow-ice-log/generate" },
        ],
      },
      {
        icon: "dollar-sign",
        title: "Accounting",
        hasArrow: true,
        subItems: [
          { title: "Invoices", link: "/invoices" },
        ],
      },
      {
        icon: "briefcase",
        title: "Company Profile",
        link: "/vendor-profile",
      },
    ],

    customer: [
      {
        icon: "tool",
        title: "Maintenance Operations",
        hasArrow: true,
        subItems: [
          {
            title: "Maintenance Requests",
            hasArrow: true,
            subItems: [
              { title: "Create Request", link: "/ticket_manager" },
              { title: "View Requests", link: "/tickets_list" },
            ],
          },
        ],
      },
    ],

    "rm vendor": [
      {
        icon: "tool",
        title: "Maintenance Operations",
        hasArrow: true,
        subItems: [
          {
            title: "Inventory",
            hasArrow: true,
            subItems: [{ title: "Orders", link: "/inventory-orders-management" }],
          },
        ],
      },
    ],

    accountant: [
      {
        icon: "dollar-sign",
        title: "Accounting",
        hasArrow: true,
        subItems: [
          { title: "KPI Report", link: "/kpi-report" },
          { title: "Upload KPI", link: "/UploadKpi" },
        ],
      },
    ],

    auditor: [
      {
        icon: "dollar-sign",
        title: "Accounting",
        hasArrow: true,
        subItems: [
          { title: "Inspection Tracker", link: "/tracker/suite-inspections" },
          { title: "Vendor Inspection Report", link: "/vendor-inspection-report" },
          { title: "Invoices", link: "/invoices" },
          { title: "Statement of Account", link: "/auditor-soa" },
        ],
      },
      ...(decoded.ticketPrivilege
        ? [
          {
            icon: "tool",
            title: "Maintenance Operations",
            hasArrow: true,
            subItems: [
              { title: "View Requests", link: "/tickets_list" },
            ],
          },
        ]
        : []),
      ...(decoded.masterSheetPrivilege
        ? [
          {
            icon: "file-text",
            title: "Mastersheet",
            hasArrow: true,
            subItems: [
              { title: "Active Mastersheet", link: "/master_sheet" },
              { title: "Archived Mastersheet", link: "/archived_master_sheet" },
              { title: "Historic Mastersheet", link: "/historic_master_sheet" },
              { title: "Resident Directory", link: "/resident_directory" },
            ],
          },
        ]
        : []),
    ],
  };

  const renderMenu = (items, level = 0) => (
    <ul
      className={level === 0 ? `list-unstyled metismenu-${props.companyClass}` : "sub-menu"}
      id={level === 0 ? "side-menu" : undefined}
    >
      {items.map((item, index) => (
        <li key={index} className={item.className || ""}>
          <Link
            to={item.link || "/#"}
            className={item.hasArrow ? "has-arrow" : ""}
          >
            {typeof item.icon === "string" ? (
              <FeatherIcon icon={item.icon} />
            ) : item.icon ? (
              item.icon
            ) : (
              <FeatherIcon icon={sidebarIconFor(item.title)} />
            )}
            <span>{props.t(item.title)}</span>
            {item.label && item.label()}
          </Link>
          {item.subItems && renderMenu(item.subItems, level + 1)}
        </li>
      ))}
    </ul>
  );

  const menuItems = roleMenus[role] || [];

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">{renderMenu(menuItems)}</div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.func,
  companyClass: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));